import { render, staticRenderFns } from "./favorite-gallery.vue?vue&type=template&id=cd12f8c0&"
import script from "./favorite-gallery.vue?vue&type=script&lang=js&"
export * from "./favorite-gallery.vue?vue&type=script&lang=js&"
import style0 from "./favorite-gallery.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd12f8c0')) {
      api.createRecord('cd12f8c0', component.options)
    } else {
      api.reload('cd12f8c0', component.options)
    }
    module.hot.accept("./favorite-gallery.vue?vue&type=template&id=cd12f8c0&", function () {
      api.rerender('cd12f8c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/favorite-gallery/favorite-gallery.vue"
export default component.exports